export const PERMISSIONS = {
  ACCOUNTS_SWITCH: 'accounts.switch',
  COMMERCIAL_READ: 'commercial.metrics.read',
  SENSITIVE_COMMERCIAL_READ: 'sensitive.commercial.read',
  AUTOMATION_CONFIGURE: 'automation.configure',
};

export const canAccess = (authorization, permission) =>
  Boolean(authorization && authorization.permissions && authorization.permissions.includes(permission));
